import { convertCarrierTemp } from "../util/convertTemp";

export class CarrierDataRes {
  rtuId = null;
  hstTemp = null;
  siteNo = null;
  totalConsPower = null;
  hstSetTemp = null;
  indoorSetTemp = null;
  deviceNo = null;
  _id = null;
  time = null;
  consPower1hAver = null;
  heatingMeteringAmount = null;
  consPowerToday = null;
  indoorTemp = null;
  powerState = null;
  powerConsCurrent = null;
  ucErrorCode = null;
  ucOpMode = null;

  constructor(data) {
    this.rtuId = data?.rtuId || 0;
    this.hstTemp = convertCarrierTemp(data?.hstTemp) || 0;
    this.siteNo = data?.siteNo || 0;
    this.totalConsPower = data?.totalConsPower || 0;
    this.hstSetTemp = convertCarrierTemp(data?.hstSetTemp) || 0;
    this.indoorSetTemp = convertCarrierTemp(data?.indoorSetTemp) || 0;
    this.deviceNo = data?.deviceNo || 0;
    this._id = data?._id || 0;
    this.time = data?.time || 0;
    this.consPower1hAver = data?.consPower1hAver || 0;
    this.indoorTemp = convertCarrierTemp(data?.indoorTemp) || 0;
    this.powerState = data?.powerState || 0;
    this.powerConsCurrent = data?.powerConsCurrent || 0;
    this.ucErrorCode = data?.ucErrorCode || 0;
    this.ucOpMode = data?.ucOpMode || 0;
    this.heatingMeteringAmount = (data?.heatingMeteringAmount || 0) * 1000;
    this.consPowerToday = data?.consPowerToday || 0;
  }

  toObject() {
    return {
      rtuId: this.rtuId,
      hstTemp: this.hstTemp,
      siteNo: this.siteNo,
      totalConsPower: this.totalConsPower,
      hstSetTemp: this.hstSetTemp,
      indoorSetTemp: this.indoorSetTemp,
      deviceNo: this.deviceNo,
      _id: this._id,
      time: this.time,
      consPower1hAver: this.consPower1hAver,
      indoorTemp: this.indoorTemp,
      powerState: this.powerState,
      powerConsCurrent: this.powerConsCurrent,
      ucErrorCode: this.ucErrorCode,
      ucOpMode: this.ucOpMode,
      heatingMeteringAmount: this.heatingMeteringAmount,
      consPowerToday: this.consPowerToday,
    };
  }

}